import React from "react";
import "./Map.scss";

const Map = (props) => {
  return (
    <div className="topMap" dangerouslySetInnerHTML={{ __html: props.map }}>
      {/* <iframe src={props.source} allowfullscreen="" aria-hidden="false" tabindex="0" width="100%" height="100%" frameborder="0"></iframe> */}
    </div>
  );
};

export default React.memo(Map);
